import { c as _c } from "react/compiler-runtime";
import type { FC, SVGProps } from "react";
export const TurnOffIcon: FC<SVGProps<SVGSVGElement>> = props => {
  const $ = _c(5);
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <title>Turn Off Icon</title>;
    t1 = <path d="M8 8L16 16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />;
    t2 = <path d="M16 8L8 16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] !== props) {
    t3 = <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}{t1}{t2}</svg>;
    $[3] = props;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};